import Client from "./DiscoveryProtocolUdp";
import { isDefined, logStdout, string2json } from "../../shared/utils";
import EventEmitter from "eventemitter3";
const client = new Client();
let timeout;
class UDPClient extends EventEmitter {
  constructor() {
    super();
    this.connections = {};
    this.client = new Client();
    this.client.startDeviceDiscoverClient(Client.Netoption);
    timeout = setTimeout(() => {
      this.clear();
      this.emit("connections", []);
    }, 5 * 1000);
    this.client.on(client.emitKey.message, (msg, rinfo) => {
      logStdout("udp client response", msg, rinfo);
      const resultMsg = string2json(msg);
      clearTimeout(timeout);
      if (isDefined(resultMsg) && isDefined(rinfo)) {
        if (resultMsg.server === "dea520") {
          this.connections[`server${rinfo.address.replace(/\./g, "")}`] = {
            ...resultMsg,
            ...rinfo
          };
          logStdout("udp servers", this.connections);
          this.emit("connections", this.connections);
        }
      }
    });
  }
  findServer() {
    this.connections = {};
    if (this.client) {
      const opt = { vendor: "Mediworks" };
      logStdout("find udp server opt", opt);
      this.client.send_msg(JSON.stringify(opt));
    }
  }
  clear() {
    if (this.client) {
      this.client.clear();
      this.connections = {};
      this.client = null;
    }
  }
}
export default UDPClient;



// WEBPACK FOOTER //
// ./src/mainInterface/js/udpClient.js